import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-grid-loading-component',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ``,
})
export class GridLoadingComponent {
  eGui!: HTMLElement;

  init() {
    this.eGui = document.createElement('div');
    this.eGui.innerHTML = `<div class="overlay table-overlay"></div>`;
  }

  getGui() {
    return this.eGui;
  }
}
